(function ($) {
    function fixSizes() {
        $('.card>.card-title-wrapper').equalizeHeight({
            equaltop: false
        })

        $('.card-footer>p').equalizeHeight({
            equaltop: false
        })
        $('.card-item .image-equal-height').equalizeHeight({
            equaltop: false
        })
        $('.stat-img').equalizeHeight({
            equaltop: false
        })
        $('.card-description p').equalizeHeight({
            equaltop: false
        })
        $('.big-cards .card-img-wrapper').equalizeHeight({
            equaltop: false
        })
        $('.card-item .card-title-wrapper').equalizeHeight({
            equaltop: false
        })
        $('.card-item .card-description-wrapper').equalizeHeight({
            equaltop: false
        })
        $('.stat-item p').equalizeHeight({
            equaltop: false
        })
        $('.blog-page .cards-section h3').equalizeHeight({
            equaltop: false
        })
    }

    var params = {
        category: null,
        city: null,
        district: null,
        lat: null,
        long: null,
        filter: null
    }
    var newParams = {...params}
    var urlStr;

    function updateParams(currentState, newState) {
        let changed = false;
        for (let parameter in newState) {
            if(newState[parameter] !== currentState[parameter]){
                params = {...newParams}
                return changed = true
            }
        }
        return changed;
    }

    function initCompanySlider() {
        $('.company-card-slider').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            rtl: true,
            arrows: false
        })
    }

    function tabs(tabContainerSelector, tabNavSelector, tabContentSelector) {
        let tabNav = $(tabNavSelector)
        let tabContent = $(tabContentSelector)
        tabNav.click(function () {
            if ($(this).hasClass('active')) {
                return
            }
            hideTab()
            showTab($(this))
        })

        function showTab(activeTab) {
            activeTab.addClass('active')
            activeTab.find('a').attr('aria-expanded','true');
            $(tabContent[activeTab.attr('tabindex') - 1]).addClass('show')
        }

        function hideTab() {
            tabNav.each(function () {
                $(this).removeClass('active')
                $(this).find('a').attr('aria-expanded','false');
            })
            tabContent.each(function () {
                $(this).removeClass('show')
            })
        }
    }

    function initTruncatedElements() {
        const elements = [
            '.card h3',
            '.card>p',
            '.card .card-description p',
            '.business-cards .card>h4',
            '.business-cards .card>p',
            '.article-cards .card-title-wrapper h3',
            '.article-cards .card-description-wrapper p',
            '.company-card-slider .card-body>p',
            '.project-history-card p',
            '.limited-height'
        ]
        const options = {
            ellipsis: "\u2026 ",
            height: 'watch',
            keep: null,
            tolerance: 0,
            truncate: "word",
            watch: "window",
        }
        elements.forEach(item => {
            let elems = document.querySelectorAll(item)
            if(elems.length){
                for(let elem of elems){
                    new Dotdotdot(elem, options)
                }
            }

        })
        $('.card-location p, .project-location p').each((_, item) => {
            if(parseInt(window.getComputedStyle(item).maxHeight) < item.scrollHeight){
                $(window).width() > 576 ? sliceList(item) : sliceList(item, 4)
            }
        })
    }

    function handleScroll() {
        statisticsSectionCountUp()
        businessStatisticsCountUp()
    }

    function initCountUp(container, {
        endVal1 = 0,
        endVal2 = 0,
        endVal3 = 0,
        endVal4 = 0
    }) {
        if (!container[0]) {
            return
        }
        let offsetTop = container[0].getBoundingClientRect().top

        if (offsetTop < 500) {
            new countUp.CountUp($('.count-1')[0], endVal1, {
                duration: 2
            }).start();
            new countUp.CountUp($('.count-2')[0], endVal2, {
                duration: 1.8
            }).start();
            new countUp.CountUp($('.count-3')[0], endVal3, {
                duration: 2
            }).start();
            new countUp.CountUp($('.count-4')[0], endVal4, {
                duration: 2
            }).start();
            $(document).off("scroll", handleScroll);
        }
    }

    function statisticsSectionCountUp() {
        initCountUp($('.statistics-section'), {
            endVal1: window.quarter_information_items.val1,
            endVal2: window.quarter_information_items.val2,
            endVal3: window.quarter_information_items.val3,
            endVal4: window.quarter_information_items.val4
        })
    }

    function businessStatisticsCountUp() {
        initCountUp($('.business-statistics'), {
            endVal1: window.businessquarterlysection.val1,
            endVal2: window.businessquarterlysection.val2,
            endVal3: window.businessquarterlysection.val3
        })
    }

    function openMobileMenu(menu) {
        menu.addClass('show')
        $('body').css({
            'overflow': 'hidden'
        })
        setTimeout(function () {
            menu.addClass('animate')
        }, 100)
        $('.toggle-menu-btn').attr('aria-expanded','true');
        $('.menu-close-btn').attr('aria-expanded','true');
        $('#main a, #footer a, .mobile-favourite-btn, .breadcrumb, .toggle-menu-btn, .header-logo, input, select, textarea, #pojo-a11y-toolbar, .pojo-skip-link, .skip-to-content-btn, #wpadminbar a').attr('tabindex','-1');
        $('#pojo-a11y-toolbar, .pojo-skip-link').fadeOut();
    }
    function closeMobileMenu(menu) {
        menu.removeClass('animate')
        setTimeout(function () {
            menu.removeClass('show')
        }, 500)
        $('body').css({
            'overflow': ''
        })
        $('.toggle-menu-btn').attr('aria-expanded','false');
        $('.menu-close-btn').attr('aria-expanded','false');
        $('#main a, #footer a, .mobile-favourite-btn, .breadcrumb, .toggle-menu-btn, .header-logo, input, select, textarea, #pojo-a11y-toolbar, .pojo-skip-link, .skip-to-content-btn, #wpadminbar a').attr('tabindex','');
        $('#pojo-a11y-toolbar, .pojo-skip-link').fadeIn();
    }

    function toggleMobileMenu(e) {
        let target = $(e.target)
        if (target.closest('.toggle-menu-btn').length) {
            e.preventDefault()
            openMobileMenu($('header'))
        }
        if (target.closest('.menu-close-btn').length) {
            e.preventDefault()
            closeMobileMenu($('header'))
        }
        if (target.hasClass('show')) {
            closeMobileMenu($('header'))
        }
    }

    function changeUrl() {
        urlStr = '';
        let isOneParam = true;
        for(let param in params){
            if(params[param]){
                isOneParam ? urlStr += `?${param}=${params[param]}` : urlStr +=`&${param}=${params[param]}`
                isOneParam = false
            }
        }
        history.pushState(params, "", urlStr.replace(/\s+/g, ''))

    }
    function hideDropdowns() {
        if($('.dropdown.show').length && updateParams(params, newParams)){
            searchRequest(searchRequestStr(params))
        }
        $('.dropdown.show').removeClass('show')
    }

    function showDropdown(dropdown) {
        if (dropdown.hasClass('show')) {
            hideDropdowns()
            return
        }
        hideDropdowns()
        dropdown.addClass('show')
    }

    function handleKeyPress(count, elements) {
        // function showActiveResult(content) {
        //     $('.location-search')[0].value = content.trim()
        // }
        let currentElement = $('.search-result li.highlighted')
        if (!currentElement[0]) {
            elements.first().addClass('highlighted')
            return
        }
        if (count > 0) {
            elements.removeClass('highlighted')
            currentElement.next().addClass('highlighted')
            // showActiveResult(currentElement.next().text())
        } else {
            elements.removeClass('highlighted')
            if (!currentElement.prev()[0]) {
                elements.last().addClass('highlighted')
            }
            currentElement.prev().addClass('highlighted')
            // showActiveResult(currentElement.prev().text())
        }
    }


    function validateFields() {
        let isValid = true
        const invalidFields = []
        const numRegex = new RegExp('[0-9]')
        const letterRegex = new RegExp('[a-zA-Z]')
        const emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$")

        validate($('.tab.show #single-firstname')[0], numRegex)
        validate($('.tab.show #single-phone')[0], letterRegex)
        validate($('.tab.show #single-email')[0], emailRegex)

        function validate(field, regex, addRequirements){
            if (!field) return
            let isInvalid = regex.test(field.value)
            if(isInvalid){
                isValid = false
                handleInvalid(field)
            }
        }
        function checkRequiredFields(){
            $('.tab.show .required').each(function (i,item){
                if(item.value.trim()){
                    $(item).parent().removeClass('no-valid')
                } else {
                    $(item).parent().addClass('no-valid')
                }
            })
            $('.tab.show fieldset.no-valid').length > 0 ? isValid = false : isValid = true
        }
        checkRequiredFields()
        function handleInvalid(field){
            field.closest('fieldset').classList.add('no-valid')
            invalidFields.push(field.labels[0].outerText)
            if(invalidFields.length > 1){
                invalidFields[invalidFields.length - 1] = 'ו' + invalidFields[invalidFields.length - 1]
            }
            let invalidFieldsStr = ''
            for(let i = 0; i < invalidFields.length; i++){
                if(i>= invalidFields.length - 2){
                    invalidFieldsStr += invalidFields[i] + ' '
                    continue
                }
                invalidFieldsStr += invalidFields[i] + ', '
            }

        }
        return isValid
    }

    function newValidateFields() {
        let valid = true;
        const form = $('.tab.show form')
        const requiredFields = form.find('[data-required="true"]')
        function validate(field) {
            const numRegex = new RegExp('[0-9]')
            const emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$")

            switch (field.type){
                case 'text':
                    valid = !!(field.value.replace(' ', '').length)
                    break;
                case 'email':
                    valid = emailRegex.test(field.value.trim())
                    break;
                case 'tel':
                    valid = numRegex.test(field.value.trim())
                    break;

            }
            if(!valid){
                $(field).closest('fieldset').addClass('no-valid')
                if(!($('.no-valid-title').length)){
                    $('.form-title').append('<h3 class="no-valid-title">יש למלא את כל שדות החובה המסומנים בכוכבית</h3>')
                }
            } else {
                $(field).closest('fieldset').removeClass('no-valid')
                $('.no-valid-title').remove()
            }
        }
        requiredFields.each((_, field) => {
            validate(field)
        })
        if(!valid && $('.no-valid-title').length){
            $('html, body').animate({
                scrollTop: $('.no-valid-title').offset().top - $('header').innerHeight() - 50
            }, 500);
        }

        return valid
    }
    function setLocationParam(field, value){
        newParams.city = null
        newParams.long = null
        newParams.lat = null
        newParams.district = null

        // let url;
        // for(let param in params){
        //     console.log(param, 'param')
        // }

        if(field){
            newParams[field] = value
        }

    }

    function getGeolocation() {
        function success(position) {
            setLocationParam()
            newParams.lat = position.coords.latitude;
            newParams.long = position.coords.longitude;
            searchRequest(searchRequestStr(params))
        }

        function error() {
            // status.textContent = 'Unable to retrieve your location';
        }

        if(!navigator.geolocation) {
            // status.textContent = 'Geolocation is not supported by your browser';
        } else {
            navigator.geolocation.getCurrentPosition(success, error);
        }

    }
    function getCookie(name) {

        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ))
        return matches ? decodeURIComponent(matches[1]) : undefined
    }

    function setCookie(name, value, props) {

        props = props || {}

        var exp = props.expires

        if (typeof exp == "number" && exp) {

            var d = new Date()

            d.setTime(d.getTime() + exp * 1000 * 60 * 60 * 24 * 365 )

            exp = props.expires = d

        }


        if(exp && exp.toUTCString) { props.expires = exp.toUTCString() }

        value = encodeURIComponent(value)

        var updatedCookie = name + "=" + value

        for(var propName in props){

            updatedCookie += "; " + propName

            var propValue = props[propName]

            if(propValue !== true){ updatedCookie += "=" + propValue }
        }

        document.cookie = updatedCookie
    }


    function defineCookies(cookieName){
        let cookie = getCookie(cookieName)
        return cookie ? JSON.parse(cookie) : []
    }

    const wishlist = defineCookies('wishlist')
    const prevSearches = defineCookies('prevSearch')
    function showFavourite(){
        const card = $('.card')
        const projectCard = $('.share-and-favourite')
        if(card.length){
            card.find('.card-favourite').removeClass('active');
            card.find('.sr-only').remove();
            card.find('.card-footer a').each(function(index, item){
                const cardIdStr = $(item).attr('href')
                const cardId = new URLSearchParams(cardIdStr.slice(cardIdStr.indexOf('/?') + 1)).get('single_project_id')
                if(wishlist.includes(cardId)){
                    $(item).parent().siblings('.card-favourite').addClass('active');
                    $(item).closest('.card').find('.remove-fav-text').after('<span class="sr-only">נשמר - לחץ להסרה</span>')
                }
            })
            $('.volunteering-icon-counter').text(wishlist.length)
        }
        const projectCardBtn = projectCard.find('.card-favourite')
        wishlist.includes(projectCardBtn.attr('data-project-id')) ? projectCardBtn.addClass('active') : projectCardBtn.removeClass('active')

    }

    function addToWishlist(){
        showFavourite()
        $(document).on('click', '.card-favourite', function (e){
            e.preventDefault()
            let cardId = $(this).siblings('.card-footer').find('a')[0].href.split('?single_project_id=')[1]
            console.log(cardId)
            if(cardId){
                let cardIdIndex = wishlist.indexOf(cardId)
                if(cardIdIndex === -1){
                    wishlist.push(cardId)
                } else {
                    wishlist.splice(cardIdIndex, 1)
                }
                setCookie('wishlist', JSON.stringify(wishlist), {
                    expires: 100,
                    path: '/'
                })
                showFavourite()
            }

        })
    }
    // function addToPrevSearch(){} previous search
    function searchRequestStr(params){
        var paramObj = {}
        var paramArr = []
        for( let paramValue in params){
            if(params[paramValue]){
                paramObj[paramValue] = params[paramValue]
            }
        }
        paramArr.push(paramObj)

        return JSON.stringify(paramArr)
    }

    function smoothScroll(target, duration){
        var target = $(target)[0]
        var targetPosition = target.getBoundingClientRect().top
        var startPosition = window.pageYOffset
        var distance = targetPosition - $('#header').outerHeight()
        var startTime = null

        function animation(currentTime){
            if(startTime === null) startTime = currentTime
            var timeElapsed = currentTime - startTime
            var run = ease(timeElapsed, startPosition, distance, duration);
            $('html')[0].scrollTop = run
            if(timeElapsed < duration) requestAnimationFrame(animation)
        }

        function ease(t, b, c, d) {
            t /= d;
            t--;
            return c*(t*t*t + 1) + b;
        };
        requestAnimationFrame(animation)
    }
    function showLoad(){
        var loader = $('.loading-block')
        var image = loader.find('img')
        var imageSrc = image.attr('src')
        if(loader.hasClass('visible')){
            loader.removeClass('visible')
            image.hide()
            return
        } else {
            loader.addClass('visible')
            image.show()
        }
    }
    function searchRequest(req){

        console.log(req)
        $.ajax({
            type: 'POST',
            url: ajax_url,
            data: {
                action: ajax_search_action,
                params: req
            },
            beforeSend: function (){
                showLoad()
                changeUrl()
            },
            success: function (res){
                showLoad()
                $('.card-section').each((index, item) => {
                    $(item).remove()
                })
                if($('.card-section').length){
                    $('.card-section').after(res)
                } else {
                    $('.main-section').after(res)
                }
            }
        })
    }

    function autocompleteRegex(word) {
        var separator = '[י]*'
        var str = word
            .split("")
            .map(item => "[" + item + "]")
            .join(separator);
        return new RegExp(
            separator + str + separator,
            "gi"
        );
    }

    function setTopMargin(selector) {
        $(selector).css({
            marginTop: $('#header').innerHeight() + $('.breadcrumb').innerHeight()
        })
    }

    function showValidateErrorLabels(invalidFieldsText, novalidElements){
        const novaidTitle = $('.form-errors-title')
        if(novalidElements.length){
            novaidTitle.text(`The following fields are missing: ${invalidFieldsText}`)
            console.log(novaidTitle)
            novaidTitle.addClass('show-novalid-title')
        } else {
            novaidTitle.removeClass('show-novalid-title')
        }
    }
    function validateFields() {
        let valid = true;
        const form = $('.tab.show form, .wpcf7-form')
        const requiredFields = form.hasClass('wpcf7-form') ? form.find('.wpcf7-validates-as-required, .wpcf7-validates-as-required.wpcf7-checkbox input') : form.find('[data-required="true"]')
        const numRegex = new RegExp(/^(\d+-?)+\d+$/)
        const emailRegex = new RegExp("^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$")
        const invalidFieldsLabels = []
        let invalidFieldsText = ''
        function validate(field) {
            let validField = true;
            const $field = $(field)
            switch (field.type){
                case 'text':
                    validField = !!(field.value.replace(' ', '').length)
                    break;
                case 'email':
                    validField = emailRegex.test(field.value.trim())
                    break;
                case 'tel':
                    validField = numRegex.test(field.value.trim()) && field.value.replace(/-/g, '').length >= 9 &&  field.value.replace(/-/g, '').length <= 10
                    break;
                case 'textarea':
                    validField = !!(field.value.replace(' ', '').length)
                    break
                case 'checkbox':
                    validField = field.checked;
                    break
                case 'select-one':
                    validField = !!field.value
                    break
                case 'fieldset':
                    validField = false
                    $(field).find('input').each(function (index, item) {
                        if(item.checked) {
                            validField = true
                        }
                    })
                    break
            }
            if($field.hasClass('wpcf7-checkbox') && !$field.find('input[type="checkbox"]').prop('checked')) {
                $field.addClass('no-valid')
            } else {
                $field.removeClass('no-valid')
            }
            if(!validField){
                $field.closest('fieldset').addClass('no-valid')
                // if(!($('.no-valid-title').length)){
                //     $('.form-title')[$('.project-page').length ? 'prepend' : 'append']('<h3 class="no-valid-title">יש למלא את כל שדות החובה המסומנים בכוכבית</h3>')
                // }
            } else {
                $field.closest('fieldset').removeClass('no-valid')
            }
            if(!validField && field.type !== 'fieldset'){
                invalidFieldsLabels.push($(`label[for=${$field.attr('id')}]`).text().replace('*', ''))
            }
            if(!validField && field.type === 'fieldset'){
                let fieldLabel = ''
                $field.find(' > label').contents().each(function(index, item) {
                    if(item.nodeType === 3 && $(item).index() <= 1) {
                        fieldLabel = item.textContent.trim().replace('*', '')
                    }
                })
                invalidFieldsLabels.push(fieldLabel)
            }

            return validField
        }
        requiredFields.each((_, field) => {
            console.log(field)
            if(!validate(field)){
                valid = false
            }
        })
        for(let i = 0; i < invalidFieldsLabels.length; i++) {
            if( i === 0 ){
                invalidFieldsText += invalidFieldsLabels[i]
            } else if( !invalidFieldsLabels[i+1]) {
                invalidFieldsText += ' and ' + invalidFieldsLabels[i]
            } else {
                invalidFieldsText += ', ' + invalidFieldsLabels[i]
            }
        }
        if(!valid){
            showValidateErrorLabels(invalidFieldsText, invalidFieldsLabels)
            $('.form-errors-title').addClass('show-error').attr('role','alert');
            $('html, body').animate({
                scrollTop: $('.form-errors-title').offset().top - $('header').innerHeight() - 50
            }, 500);
            $('.no-valid [data-required="true"], .no-valid .wpcf7-validates-as-required, .no-valid.wpcf7-checkbox input').first().focus()
        }
        return valid
    }

    function initArticlesLoadBtn(cardsLength, paginationOffset) {
        if(cardsLength <= paginationOffset) {
            $('.load-more-articles-btn').addClass('hide')
        }
    }

    function loadArticles() {
        const section = $('.cards-section__article_cards')
        const cards = section.find('[data-show="false"]')
        const paginationOffset = 6


        for(let i = 0; i < paginationOffset; i++) {
            cards.eq(i).attr('data-show', true)
        }

        initArticlesLoadBtn(cards.length, paginationOffset)

    }

    function removeOutlineOnClick() {

        var usingMouse;
        var body = document.body;

        var preFocus = function (event) {
            usingMouse = (event.type === 'mousedown');
        };

        var addFocus = function (event) {
            if (usingMouse)
                event.target.classList.add('focusMouse');
        };

        var removeFocus = function (event) {
            event.target.classList.remove('focusMouse');
        };

        var bindEvents = function () {
            body.addEventListener('keydown', preFocus);
            body.addEventListener('mousedown', preFocus);
            body.addEventListener('focusin', addFocus);
            body.addEventListener('focusout', removeFocus);
        };

        bindEvents();
    }

    $(document).ready(function () {
        var customCheckboxCounter = 1;
        $('label.custom-checkbox').each( (i,el) => {
            const id = 'r-custom-checkbox-' + customCheckboxCounter++
            $(el).attr('for',id);
            $(el).find('input[type="checkbox"]').attr('id',id);
        });
        if(getCookie('changedContrast') && JSON.parse(getCookie('changedContrast'))) {
            $('body').addClass('high-contrast');
            $('.contrast-toggler').attr('aria-pressed','true');
        } else {
            setCookie('changedContrast', false, {expires: 10000})
        }
        $('.contrast-toggler').on('click', function(e) {
            e.preventDefault();
            $('body').toggleClass('high-contrast');
            if($('.contrast-toggler[aria-pressed="false"]').length){
                $('.contrast-toggler').attr('aria-pressed','true');
            }else{
                $('.contrast-toggler').attr('aria-pressed','false');
            }
            setCookie('changedContrast', !JSON.parse(getCookie('changedContrast')), {expires: 10000})
        })
        $('input[type="file"]').on('change', function(){
            readURL(this)
        })
        $('.custom-upload').on('click', function (e){
            const fileInput = $(this).find('input[type="file"]')
            if(fileInput.attr('disabled')){
                e.preventDefault()
                fileInput[0].value = ''
                fileInput.removeAttr('disabled')

            }
        })
        document.addEventListener( 'wpcf7invalid', function( e ) {
            const feedbackMsg = $('.wpcf7-response-output')
            $(e.target).find('form').prepend(feedbackMsg)
            setTimeout(()=>{
                showInvalidFields(e)
                $('html, body').animate({
                    scrollTop: feedbackMsg.offset().top - $('header').innerHeight() - 50
                }, 500);
            }, 0)

        }, false );

        document.addEventListener( 'wpcf7mailsent', function( e ) {
            $('.form-wrapper').addClass('form-sent')
            $(e.target).find('form').hide()
            $('body, html').scrollTop(0)
            history.pushState({}, null, '?thankyou');
        }, false );
        if($('.project-location').innerWidth() > 300){
            sliceList()
        }
        if($('.organization-search-section').length){
            organizationShowInitialCards()
        }
        $('.form-find-project .btn').on('click', newValidateFields)

        // fixSizes()
        // toggleLocationDropdown()
        // initTruncatedElements()
        addToWishlist()
        $(document).on('click', '.get-geo', () => {
            $('.dropdown.show').removeClass('show')
            getGeolocation()
        })
        $('input[name="filter"]').on('change', function (){
            if(this.checked){
                newParams.filter = $(this).attr('value')
            } else {
                newParams.filter = null
            }
            updateParams(params, newParams)
            searchRequest(searchRequestStr(params))

        })
        $(document).click(function (e) {
            let dropdown = e.target.classList.contains('dropdown')
            let dropdownContainer = $(e.target).closest('.dropdown, .card-location')

            if (dropdown) {
                showDropdown(dropdownContainer)
            }
            if (!dropdownContainer.length) {
                hideDropdowns()
            }
            toggleMobileMenu(e)
            if ($('header').hasClass('show')) {
                $('.right-header-part').append($('.header-nav'))
            }
        })
        $(document).scroll(handleScroll)
        $(document).keyup(function (e) {
            if (e.key === 'Escape') {
                hideDropdowns()
            }
        })
        $('.organization-search').on('keydown click', function (e){
            switch (e.keyCode) {
                case 40:
                    organizationListSetActive(1)
                    break;
                case 38:
                    organizationListSetActive(-1)
                    break;
                case 13:
                    e.preventDefault()
                    $(this).blur()
                    showLoad()
                    setTimeout(() => {
                        searchOrganizationList(this)
                        showLoad()
                    }, 1000)

                    break;
            }
        })
        $('.organization-search-wrapper .search-icon').on('click', function (e){
            let input = $(this).siblings('input')
            input.blur()
            showLoad()
            setTimeout(() => {
                searchOrganizationList(input[0])
                showLoad()
            }, 1000)
        })
        $('.organization-search-result').on('mouseover', function(e){
            for(let child of this.children){
                if(child === $(e.target).closest('li')[0]){
                    child.classList.add('highlighted')
                } else {
                    child.classList.remove('highlighted')
                }
            }
        })
        $('.organization-search-result').on('mouseleave', function(e){
            $('.organization-search-result li').removeClass('highlighted')
        })
        $('.organization-search-result').on('mousedown', function(e){
            if($(e.target).attr('data-project-name')){
                redirectToSingleOrganization($(e.target).attr('data-project-name'))
            }
        })
        initCompanySlider();
        $('.company-card-slider .slick-slide').attr('tabindex','0');
        $('.company-card-slider .slick-slide').removeAttr('aria-hidden');
        $('.company-card-slider .slick-slide').removeAttr('role');
        tabs('.project-form-tabs', '.tab-nav li', '.tab-content .tab')
        $('.location-search').on('keydown', function (e) {
            let elements = $('.search-input-wrapper .search-result li')

            switch (e.keyCode) {
                case 40:
                    handleKeyPress(1, elements)
                    break;
                case 38:
                    handleKeyPress(-1, elements)
                    break;
                case 13:
                    e.preventDefault()
                    $('.field-wrapper .city-search-input')[0].value = $('.search-result li.highlighted').text().trim()

                    hideDropdowns()
                    break;
            }

        })
        $('.search-result').on('click keydown', function (e) {
            e.preventDefault()
            var targetValue = $(e.target).closest('li a')
            $('.field-wrapper .city-search-input')[0].value = targetValue.text().trim()
            setLocationParam(targetValue.attr('data-param-name'), targetValue.attr('data-param-value'))
            hideDropdowns()
            $('.location-search')[0].value = ''
        })
        $('.location-list').on('click', function (e){
            e.preventDefault()
            var targetValue = $(e.target)
            if(targetValue.attr('data-param-value')){
                $('.field-wrapper .city-search-input')[0].value = targetValue.text().trim()

                setLocationParam(targetValue.attr('data-param-name'), targetValue.attr('data-param-value'))
                hideDropdowns()
            }
        })
        $('.field-wrapper').on('click', function (){
            if(!($(this).hasClass('show')) && $(window).innerWidth() <= 576){
                smoothScroll(this, 750)
            }
        });
        $('.toggle-list-view').on('click', function (e) {
            e.preventDefault()
            $(this).closest('.cards-section').removeClass('cards-section-with-slider').addClass('cards-section-without-slider')
            $(this).closest('.cards-section').find('.title-with-line').removeClass('hide')
            $(this).addClass('hide')

            initTruncatedElements()
            fixSizes()
        })

        $(document).on('click', '.footer-section-link-wrapper a', function (e){

            e.preventDefault()
            if(urlStr && params.category){
                window.location.href = `https://www.ruachtova.org.il/en/pagesearchresults/${urlStr}`
            } else {
                var str = ''
                for(let param in params){
                    if(params[param]){
                        str += `&${param}='${params[param]}'`
                    }
                }
                window.location.href = this.href + str
            }
        })
        $('.checkbox-list').on('click', function() {
            var checkboxes = $('.checkbox-list input[type="checkbox"]:checked')
            var searchStr = ''
            checkboxes.each(function (index, item){
                if(index > 0){
                    searchStr += ', '+$(item).attr('data-param-value')
                } else {
                    searchStr += $(item).attr('data-param-value')
                }
            })
            newParams.category = searchStr
            $('.category-search-input')[0].value = searchStr
        })

        $('.search-result').on('mouseover', function (e) {
            let currentEl = $(e.target).closest('li')
            let elements = $('.search-input-wrapper .search-result li')
            if (currentEl) {
                elements.removeClass('highlighted')
                currentEl.addClass('highlighted')
            }
        })
        $('.location-search').on('input', function () {
            var inputVal = this.value.replace(/י/g, '').trim().toLowerCase()
            var words = inputVal.split(' ')
            var content = '<li class="get-geo">השתמשו במיקום הנוכחי שלי</li>'
            $('.search-result').html(content)
            if (this.value.length > 1) {
                let regexArr = []
                for (let word of words){
                    var newWord = word.replace(' ', '')
                    if(newWord.length){
                        regexArr.push(autocompleteRegex(newWord))
                    }
                }
                var maxResultCount = $(window).width <= 576 ?
                    $(this).attr('data-max-result-count-mobile') :
                    $(this).attr('data-max-result-count-desktop')
                var results = cities_list
                    .filter(item => {
                            let isOk = false;
                            for(let regex of regexArr){
                                isOk = regex.test(item.name_heb.replace(/י/g, ''))
                                if(!isOk){
                                    return isOk
                                }
                            }
                            return isOk
                        }
                    )
                    .sort((a,b) => (a.name_heb.replace(/י/g, '')).indexOf(inputVal) - (b.name_heb.replace(/י/g, '')).indexOf(inputVal))
                    .slice(0, maxResultCount)


                for (let result of results) {
                    let boldText = result.name_heb
                    for(let regex of regexArr){
                        boldText = boldText.replace(regex, `<b>${result.name_heb.match(regex)[0]}</b>`)
                    }
                    content += '<li data-param-name="city" data-param-value="'+ result.name_heb +'">' +
                        '<a href>'+boldText+'</a>'
                    '</li>';
                }
            } else {
                content = '<li class="get-geo">השתמשו במיקום הנוכחי שלי</li>'
            }
            $('.search-result').html(content)
        })
        $('.location-search').on('click', function (e) {
            $(this).closest('.dropdown-content').addClass('overlayed')
            $('.search-result').addClass('show')
            $('.location-search').trigger('input')
        })
        $('#location-search , #categories-search').on('keyup', function (e) {
            if(e.originalEvent.keyCode == 13){
                e.preventDefault();
                $(this).closest('.dropdown-content').addClass('overlayed')
                $(this).closest('.dropdown ').addClass('show')
            }

        })
        $(window).on('load resize orientationchange', function () {
            $('.mobile-carousel').each(function () {
                var $carousel = $(this);
                /* Initializes a slick carousel only on mobile screens */
                // slick on mobile
                if ($(window).width() > 576) {
                    if ($carousel.hasClass('slick-initialized')) {
                        $carousel.slick('unslick');
                    }
                } else {
                    if (!$carousel.hasClass('slick-initialized')) {
                        $carousel.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            mobileFirst: true,
                            rtl: true,
                            dots: true
                        });
                    }
                }
            });
            $('.card-container').each(function(){
                const cardContainer = $(this)
                const cityListContainer = cardContainer.find('.cities-expanded-list')
                if(cityListContainer.length){
                    const index = cardContainer.index() + 1
                    if(!(index % 3)){
                        alignCityList(cardContainer, cityListContainer, 'right')
                    } else if(!(index % 2)){
                        alignCityList(cardContainer, cityListContainer,'center')
                    } else {
                        alignCityList(cardContainer, cityListContainer,'left')
                    }
                }
            })
        });
        setTopMargin('#main')
        if($('.wpcf7-select').length ) {
            $('.wpcf7-select').select2({
                minimumResultsForSearch: -1,
                width: '100%',
                dir: 'ltr',
                placeholder: "Please select",
            })
        }
        $(document).on('click','.form-tab .btn', validateFields)
        if ($(window).width() < 767) {
            $('.about-us-text p:nth-child(3)').after($('.about-us-info .img-holder'))
            $('.footer-links').append($('#footer .languages'))
        }
        // loadArticles()
        removeOutlineOnClick()
        $('.load-more-articles-btn').on('click', function(e) {
            e.preventDefault()
            loadArticles()
            initTruncatedElements()
            fixSizes()
        })
        $('.to-form-btn').on('click', function(event) {
            sessionStorage.setItem('data', JSON.stringify(
                {'page-from': document.title,
                'block-from': $(this).closest('.card').find('h3 a').text().trim()
                })
            )
        })
        if($('.wpcf7-form').length) {
            const pageFromData = JSON.parse(sessionStorage.getItem('data'))

            for(let prop in pageFromData) {
                if(pageFromData.hasOwnProperty(prop) && pageFromData[prop]) {
                    $(`#${prop}`).val(pageFromData[prop])
                }
            }
        }
        ;(function() {
            const section = $('.load-more-articles-btn').closest('.cards-section')
            initArticlesLoadBtn(section.find('.card-container').length, section.find('.card-container[data-show="true"]').length)
        })();

    });
    $(window).on('load', function () {
        initTruncatedElements()
        fixSizes()
        setTopMargin('#main')
        if ($(window).width() < 767) {
            $('.footer-links').append($('#footer .languages'))
            $('.about-us-text p:nth-child(3)').after($('.about-us-info .img-holder'))
        }
        if ($(window).width() < 992) {
            $('.right-header-part .menu-close-btn').after($('.contrast-toggler-wrapper'))
        } else {
            $('.header-links .contact-us').after($('.contrast-toggler-wrapper'))
        }
        if($('#pojo-a11y-toolbar').length){
            $('.skip-to-content-btn').after($('#pojo-a11y-toolbar'));
        }
        $('#sign-up-schedule + .select2 .select2-selection').attr('aria-label','*How many times a week can you volunteer?')
        $('#sign-up-term + .select2 .select2-selection').attr('aria-label','*For how long would you like to commit?')

    })
    $(window).resize(function () {
        fixSizes()
        setTopMargin('#main')
        $(window).width() < 576 ? $('.page-not-found-text p').after($('.page-not-found-img')) : null
        if ($(window).width() < 768 && !$('#footer .languages').parent('.footer-links').length) {
            $('.footer-links').append($('#footer .languages'))
        } else if ($(window).width() >= 768 && $('#footer .languages').parent('.footer-links').length) {
            $('.footer-bottom-bar .footer-nav').append($('#footer .languages'))
        }
        if ($(window).width() < 767) {
            $('.about-us-text p:nth-child(3)').after($('.about-us-info .img-holder'))
        }
        if ($(window).width() < 992) {
            $('.right-header-part').prepend($('.contrast-toggler-wrapper'))
        } else {
            $('.header-links .contact-us').after($('.contrast-toggler-wrapper'))
        }
    })

    $(document).on('afterShow.fb',function (e){
        $('.fancybox-button--close').attr('aria-label','לחץ לסגירה או המשך לנווט לתוכן החלונית').focus();
    });

})(jQuery)